import { createAction, ActionsUnion } from '@housinganywhere/safe-redux';

import { Thunk } from 'ha/myredux/types';
import { Conversation } from 'ha/services/apiV2/types/Conversation';

export enum ActionTypes {
  LOAD_CONVERSATIONS_DONE = '[PAYMENT_REQUEST_MODAL] LOAD_CONVERSATIONS_DONE',
  LOAD_CONVERSATIONS_FAIL = '[PAYMENT_REQUEST_MODAL] LOAD_CONVERSATIONS_FAIL',
  LOAD_CONVERSATIONS_START = '[PAYMENT_REQUEST_MODAL] LOAD_CONVERSATIONS_START',
}

export const actions = {
  done: (conversations: Conversation[]) =>
    createAction(ActionTypes.LOAD_CONVERSATIONS_DONE, conversations),
  fail: () => createAction(ActionTypes.LOAD_CONVERSATIONS_FAIL),
  start: () => createAction(ActionTypes.LOAD_CONVERSATIONS_START),
};

export type Actions = ActionsUnion<typeof actions>;

export default (): Thunk => (dispatch, _, { apiV2 }) => {
  dispatch(actions.start());

  return apiV2
    .getConversations('me', {
      asAdvertiser: true,
      excludeMoveOutOlderThan: 3,
      expand: 'listing,tenant',
      state: 'paidAndCancelled',
    })
    .then(({ data: { conversations } }) => {
      dispatch(actions.done(conversations));
    })
    .catch(() => {
      dispatch(actions.fail());
    });
};
